export default "assets/shipping-62d5bd88.svg";